<template>
    <v-container>
        <v-radio-group
          v-model="selectedOption"
          mandatory
          row
          class="mr-n8"
          
        >
          <v-radio
            v-for="(item, i) in extraOptions"
            :key="item"
            :label="item"
            :value="i"
          ></v-radio>
        </v-radio-group>
        <!-- select number -->
        <v-row align="center" v-if="selectedOption === 0">
          <v-btn
            plain
            text
            x-large
            class="text-h6 font-weight-medium fontGey--text pr-0 text-right"
            @click="selectedDid = null"
          >
            בחירת מספר חדש:
          </v-btn>
          <p class="fontGrey--text text-h6 mb-0">
            <!-- בחירת מספר חדש: -->
            <span v-if="selectedDid" class="font-weight-bold pr-6">
              {{ formated(selectedDid) }}
            </span>
          </p>
        </v-row>
        <v-row v-if="validNumbers && selectedOption === 0">
          <v-col cols="1" class="pa-0">
            <v-btn
              plain
              text
              x-large
              class="text-h6 font-weight-medium fontGey--text pr-0 text-right"
              @click="moreNumbers"
            >
              עוד
            </v-btn>
          </v-col>
          <v-col class="pa-0">
            <v-btn
              plain
              text
              x-large
              class="text-h6 font-weight-medium fontGrey--text"
              v-for="(number, i) in getNumbersSequence(displayMoreIndex)"
              :key="i"
              @click="handleDidSelect(number)"
              >
              {{ formated(number) }}
              <!-- :class="hasSelected ?  'fontGrey--text' : 'fadedSecondary--text'" -->
              <!-- :disabled="hasSelected" -->
              <!-- @click="$emit('selectedNumber', number)" -->
              </v-btn
            >
          </v-col>
        </v-row>
        <v-row align="start" v-if="selectedOption === 1">
          <v-col  cols="12" md="4" class="pa-0">
            <v-btn
              plain
              text
              x-large
              class="text-h6 font-weight-medium fontGey--text pr-0 text-right"
            >
              ניוד מספר קיים
            </v-btn>
          </v-col>
          <v-col  cols="12" md="4" class="pa-0">
            <v-text-field
              dir="ltr"
              outlined
              dense
              v-model="selectedDid"
              autofocus
              placeholder="הכנס מס טלפון"
              v-mask="'##########'"
              :rules="phoneRules"
              required
            >
            </v-text-field>
          </v-col>
        </v-row>
        <!-- otp -->
        <v-row v-if="selectedOption === 1">
          <v-col  cols="12" md="4" class="pa-0">
            <v-btn
              plain
              text
              x-large
              class="text-h6 font-weight-medium fontGey--text pr-0 text-right"
              @click="askForOtp"
            >
              שלח קוד אימות
            </v-btn>
          </v-col>
          <v-col v-if="displayOtp" dir="ltr" class="pa-0">
            <v-otp-input
              v-model="otp"
              length="4"
              @finish="onFinish"
            ></v-otp-input>
          </v-col>
        </v-row>
        <v-row v-if="selectedOption === 1">
          <v-col class="pa-0">
            <p class="fontGrey--text text-h6 font-weight-medium mb-0">
              לאישור הבעלות על המספר, יש להכניס את הקוד שקבלת בסמס
            </p>   
          </v-col>
        </v-row>
        <v-row>
          <DidAddPopup
            :message="message"
            :confirmMessage="confirmMessage"
            :selectedDid="formated(selectedDid)"
            v-model="displayMessage"
            @createNewDID="purchaseProcedure"
          />
              <ConfirmPopup
                v-model="displayAlert"
                :label="label"
                :message="message"
                :otpConfirm="true"
                @finish="$emit('selectedNumber', selectedDid)"
                />
        </v-row>
        <!-- end  -->
    </v-container>
</template>

<script>
import isNil from "lodash/isNil";
import chunk from "lodash/chunk";
 import trimStart from "lodash/trimStart";
  import apiCalls from "@/mixins/apiCalls.js";
  import inputRules from "@/mixins/inputRules";
import { userNumber, formatInternationalNumber } from "@/utils/lib.js";

export default {
    name: 'AddDID',
    mixins: [apiCalls, inputRules],
  components: {
   
    DidAddPopup: () =>
      import("@/components/CommonComponents/Dialogs/DidAddPopup"),
    ConfirmPopup: () =>
    import("@/components/CommonComponents/Dialogs/ConfirmPopup"),
  },
  data() {
    return {
     
    //   check what is used
    validNumbers: null,
      loaded: false,
    displayMore: false,
      displayMoreIndex: 0,
      selectedDid: null,
      displayPortingNumberInput: false,
      displayOtp: false,
      otp: null,
      allowAddNumber: false,
 displayMessage: false,
      selectedCountry: null,
      selectedOption: 0,
      extraOptions: ["מספר חדש", "ניוד מספר קיים"],
      userMobiles: null,
      message: "",
      confirmMessage: false,
      newDidCreated: false,
      label: '',
      displayAlert: false
    };
  },
  mounted() {
    this.fetchValidNumbers();
  },
  computed: {
    userPortingPhone() {
      return "972" + trimStart(this.selectedDid, "0");
    },
    hasSelected() {
      return !isNil(this.selectedDid) ? true : false;
    },
  },
 watch: {
  allowAddNumber(val) {
    if(val) this.$emit('selectedNumber', this.userPortingPhone)
  }
 },
  methods: {
    formated(stringNum) {
      if (this.isInternational) return formatInternationalNumber(stringNum);
      return userNumber(stringNum);
    },
    purchaseProcedure() {
      this.displayMessage = false;
      this.message = 'שלח הודעה לאישור מנהל החשבון'
      this.label = 'שירות בתשלום '
      this.displayAlert = !this.displayAlert;
    },
    async onFinish() {
      console.log("finish otp...");
      const appAction = true;
      const functionName = "validate_otp";
      const reqBody = {
        number: this.userPortingPhone, //required
        code: this.otp, //required
        device_details: {},
        registration: true, //if it's registration
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      // console.log('from otp finish -> ', data);
      if (data.error_code === 200) {
        this.displayOtp = false;
        this.allowAddNumber = true;

      }
    },
    async sendOTP() {
      const appAction = true;
      const functionName = "send_otp";
      const reqBody = {
        number: this.userPortingPhone, // required
        method: "SMS", // SMS | CALL - req  flag ? "SMS" : "CALL",
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      console.log("send otp data : ", data);
      if (data.error_code === 200) {
        // this.displayOtpInput = !this.displayOtpInput;
        // this.displayButtons = false;
        // this.allowAddNumber = true;
        // this.displayOtp = false;
      }
    },
    async fetchValidNumbers() {
      //   console.log(" fetch validNumbers ");

      this.loaded = false;
      const appAction = true;
      const functionName = "get_available_numbers";
      let settings = {
        international: {
          mobile: this.isInternational ? 1 : 0,
        },
        home: {
          mobile: this.isInternational ? 0 : 1,
        },
      };
      const reqBody = {
        test: "74be16979710d4c4e7c6647856088456",
        settings: settings,
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      //   console.log("validNumbers data ", data);
      if (data.error_code === 200) {
        this.validNumbers = this.isInternational
          ? chunk(data.data.international, 3)
          : chunk(data.data.home.mobile, 3);
        this.loaded = true;
      }
    },
    askForOtp() {
      //add logic
      //display otp input
      this.displayOtp = true;
      this.sendOTP()
    },
    handleDisplayMore() {
      this.displayMore = !this.displayMore;
      this.moreNumbers();
    },
    getNumbersSequence(index) {
      return this.validNumbers[index];
    },
    moreNumbers() {
      if (this.displayMoreIndex < this.validNumbers.length)
        this.displayMoreIndex++;
      if (this.displayMoreIndex == this.validNumbers.length)
        this.displayMoreIndex = 0;
    },
    handleDidSelect(number) {
      if(number) {
        this.selectedDid = number
        this.$emit('selectedNumber', this.selectedDid)
      }
    }
  }
}
</script>